import React from 'react';

const CommunitySection = () => {
  const aiServices = [
    {
      title: '[GitHub]',
      description: 'Cloud / AI / Code Repository',
      link: 'https://github.com/arabangoo'
    },
    {
      title: '[Medium]',
      description: 'Cloud / AI / SNS / Blog',
      link: 'https://arabangoo.medium.com'
    },
    {
      title: '[한국인공지능진흥협회(KAIPA)]',
      description: 'AI/ML Research',
      link: 'https://huggingface.co/openfree'
    }
  ];

  return (
    <section className="service-section">
      <h2>Community</h2>
      <div className="ai-links">
        {aiServices.map((service, index) => (
          <div key={index} className="ai-service">
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <a href={service.link} target="_blank" rel="noopener noreferrer">
              {service.link}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CommunitySection;
